/**
 * Telegram WebApp 的类型化访问入口。
 *
 * 这里只给 `window.Telegram.WebApp` 加类型和兜底，不是在包装 SDK ——
 * 那个对象由 Telegram 注入，直接用即可。
 */

interface TelegramWebApp {
  initData: string
  initDataUnsafe?: { start_param?: string }
  platform: string
  colorScheme: 'light' | 'dark'
  themeParams?: Record<string, string>
  ready(): void
  expand(): void
  openTelegramLink(url: string): void
  disableVerticalSwipes?(): void
  BackButton?: { show(): void; hide(): void; onClick(cb: () => void): void }
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp }
  }
}

export function webApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null
}

/** 在 Telegram 客户端外打开时为 false —— 此时拿不到 initData，只能看免费集。 */
export function insideTelegram(): boolean {
  return Boolean(webApp()?.initData)
}

export function initData(): string {
  return webApp()?.initData ?? ''
}

/**
 * platform 只能当弱信号做统计，**不能当门禁**：
 * 它不在 initData 的签名范围内，客户端可以随便改。
 */
export function platform(): string {
  return webApp()?.platform ?? 'unknown'
}

/** 跳转到机器人深链。会关闭当前 Mini App，由机器人的按钮把用户送回来。 */
export function openBotLink(url: string): void {
  const app = webApp()
  if (app) app.openTelegramLink(url)
  else window.location.href = url
}

export function ready(): void {
  const app = webApp()
  if (!app) return
  app.ready()
  app.expand()
  // 竖屏播放时下滑会误触 Telegram 的关闭手势
  app.disableVerticalSwipes?.()
}
